export default __webpack_public_path__ + "static/media/trusted_baker_512.ed40eb51.png";